module.exports = __webpack_public_path__ + "img/product-reviews.e218b724.png";